import OneSignal from 'react-onesignal';
import { localStorageKey } from './constants/LocalStorageKey';
import constant from './constants/Constatnt';


export default async function runOneSignal() {
  const appId = constant.appHostsAndIds.find(appHostAndId => appHostAndId.host === window.location.host)?.appId || '84457af4-a978-4e3f-92a0-3dc3fff6c82a';
  await OneSignal.init({ appId, allowLocalhostAsSecureOrigin: true});
  OneSignal.showSlidedownPrompt();
  OneSignal.getUserId().then((userId) => {
   sessionStorage.setItem(localStorageKey.USERID, userId);
  })
}